var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayoutSticky = function SvgLayoutSticky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-1",
    d: "M64 51v2H8v-2h6V41c0-1.1.9-2 2-2h40c1.1 0 2 .9 2 2v10h6Z",
    fill: "#80B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-3",
    d: "M49 45H23v2h26v-2Z",
    fill: "#EBF2FF"
  })));
};
export default SvgLayoutSticky;